<template>
  <main>
    <nav v-if="selectedStage == 1" :class="style.additional">
      <div
        :class="specializationSelected == '' ? style.active : ''"
        @click="specializationSelected = ''"
      >
        Все
      </div>
      <div
        :class="specializationSelected == specialization ? style.active : ''"
        @click="specializationSelected = specialization"
        v-text="specialization"
        v-show="verifySpecialization(specialization)"
        v-for="specialization in getSpecializationList"
      />
    </nav>
    <div @click="setAnyDoctor()" :class="style.doctor">
      <div :class="style.mainBlock">
        <div
          v-if="'photo' in chose.doctor"
          :class="style.photo"
          :style="{
            backgroundImage: `url(${getMiniPhoto(getDoctorPhoto(chose.doctor.photo), 'vrach.png')})`
          }"
        />
        <div :class="style.info">
          <h3 v-text="'Любой специалист'"></h3>
          <div>
            <p v-if="specializationSelected" v-text="specializationSelected" />
            <p
              v-else
              v-text="
                getSpecializationList
                  .filter((spec: string) => {
                    return verifySpecialization(spec);
                  })
                  .join(', ')
              "
            />
          </div>
        </div>
      </div>
      <div :class="style.choiceDoctor" />
    </div>
    <div
      :key="doctor.id"
      v-for="doctor in getDoctors"
      v-show="verifyDoctor(doctor)"
      @click="setChoiceDoctor(doctor)"
      :class="style.doctor"
      :id="String(doctor.id)"
    >
      <div :class="style.mainBlock">
        <p
          :class="style.experience"
          v-if="doctor.experience"
          v-text="doctor.experience"
        />
        <div
          :class="style.photo"
          :style="{
            backgroundImage: `url(${getMiniPhoto(getDoctorPhoto(doctor.photo), 'vrach.png')})`
          }"
        />
        <div :class="style.info">
          <h3 v-text="doctor.name"></h3>
          <div>
            <p v-text="doctor.specialization.join(', ')" />
          </div>
        </div>
      </div>
      <div :class="style.choiceDoctor" />
    </div>
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import {doctor} from "@/page/onlineAppointment/doctors/DoctorsType";
import type {chose} from "../WidgetTypes";
import type {clinic} from "@/page/onlineAppointment/clinic/ClinicTypes";
import {getDoctorPhoto, getMiniPhoto} from "../ScriptsWidget";
export default defineComponent({
  name: "ChoseDoctor",
  data() {
    return {
      style,
      specializationSelected: "",
      getDoctorPhoto,
      getMiniPhoto
    };
  },
  methods: {
    setAnyDoctor() {
      this.chose.DoctorName = this.specializationSelected
        ? "Любой " + this.specializationSelected
        : "Любой";
      this.chose.doctor = {id: "All", service: {}};
      this.getDoctors
        .filter((f) => {
          return f.service != null;
        })
        .forEach((doctor) => {
          Object.keys(doctor.service).forEach((key) => {
            const selectedDoctor = this.chose.doctor;
            if (!selectedDoctor.service) {
              return;
            }
            if (this.specializationSelected) {
              if (
                doctor.specialization.indexOf(this.specializationSelected) != -1
              ) {
                selectedDoctor.service[key] = doctor.service[key];
              }
            } else {
              selectedDoctor.service[key] = doctor.service[key];
            }
          });
        });
      this.$widgetStore.setSelectedStage(this.selectedStage + 1);
    },
    verifySpecialization(specialization: string) {
      let verify = false;
      this.getDoctors.forEach((doctor) => {
        if (doctor.specialization.includes(specialization)) {
          verify = true;
        }
      });
      return verify;
    },
    setChoiceDoctor(doctor: doctor) {
      this.chose.DoctorName = doctor.name;
      this.chose.doctor = doctor;
      this.$widgetStore.setSelectedStage(this.selectedStage + 1);
    },
    verifyAddressInDoctor(doctor: doctor) {
      let verify = false;
      for (const address in doctor.address) {
        if (Object.hasOwnProperty.call(doctor.address, address)) {
          const checked = doctor.address[address];
          if (checked) {
            verify = this.getAddressList.includes(address);
          }
        }
      }
      return verify;
    },
    verifyDoctor(doctor: doctor) {
      if (this.navWidget == "ВРАЧИ") {
        if (this.specializationSelected == "") {
          if (this.getAddressList.length < 2) {
            return true;
          }
          return this.verifyAddressInDoctor(doctor);
        }
        if (doctor.specialization.includes(this.specializationSelected)) {
          return this.verifyAddressInDoctor(doctor);
        }
        return false;
      }
      let serviceList: string[] = [];
      Object.values(doctor.service).forEach((serviceArr) => {
        serviceArr.forEach((service) => {
          if (service.checked) {
            let objServise = this.getObjService(service);
            serviceList.push(Object.values(objServise).join(", "));
          }
        });
      });
      if (serviceList.includes(this.chose.DoctorService)) {
        return this.verifyAddressInDoctor(doctor);
      }
      return false;
    },
    getObjService(servise: doctor["service"][string][number]) {
      function splitLastOccurrence(str: string, substring: string) {
        const lastIndex = str.lastIndexOf(substring);
        if (lastIndex == -1) {
          return [str, 0];
        }
        return [str.slice(0, lastIndex), str.slice(lastIndex + 1)];
      }
      let serviceSplit = splitLastOccurrence(servise.name, ", ");
      if (serviceSplit.length == 1) {
        serviceSplit = splitLastOccurrence(servise.name, " - ");
      }
      if (serviceSplit.length == 3) {
        serviceSplit[1] = serviceSplit[2];
        serviceSplit.pop();
      }
      let cost = serviceSplit[1] ? serviceSplit[1] : "0";
      if (cost == "0") {
        cost = servise.cost ? servise.cost : "0";
      }
      cost = String(cost);
      let prefix;
      if (cost.replaceAll(" ", "").slice(0, 2).toLowerCase() == "от") {
        prefix = "от";
      }
      cost = cost.replace(/\s/g, "");
      cost = String(cost.match(/\d+/g));
      if (cost.length > 4) {
        cost = cost.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (prefix != undefined) {
        cost = prefix + " " + cost;
      }
      let symbol = this.getClinic?.currency?.symbol;
      cost += symbol ? " " + symbol : " ₽";
      cost = cost.replace(/ /g, "\u00a0");
      let name = serviceSplit[0];
      return {name, cost};
    }
  },
  computed: {
    getDoctors(): doctor[] {
      return this.$widgetStore.getDoctors;
    },
    getClinic(): Partial<clinic> {
      return this.$widgetStore.clinic;
    },
    getAddressList(): string[] {
      return this.getClinic?.addressList || [];
    },
    getSpecializationList(): string[] {
      return this.getClinic?.specializationList || [];
    },
    chose(): chose {
      return this.$widgetStore.getChose;
    },
    selectedStage() {
      return this.$widgetStore.getSelectedStage;
    },
    navWidget() {
      return this.$widgetStore.getNavWidget;
    }
  }
});
</script>
